import React from "react";

// external imports
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box } from "@mui/material";

export default function NotificationsSnackbarComp({
  open,
  onClose,
  errorMessage,
  notificationType,
}) {
  const messages = Array.isArray(errorMessage) ? errorMessage : [errorMessage];
  const getSeverity = (notificationType) => {
    if (notificationType === "error") {
      return "error";
    } else {
      return "info";
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={10000}
      onClose={onClose}
      sx={{ zIndex: 10 }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={getSeverity(notificationType)}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {messages.map((message, index) => (
          <Box key={index}>{message}</Box>
        ))}
      </Alert>
    </Snackbar>
  );
}
